import {observer} from "mobx-react"
import {useNavigate, useSearchParams} from "react-router"
import {Linq, Page, Pager, ScrollTable, Searchbar} from "../../ui"
import {pageQueryStore, vdaOverviewStore} from "../../../store"
import {convertStatus} from "../../../api";
import {dateFormat} from "../../../utils";
import {PageContentTitle} from "@kroschke/react-ui";
import {useEffect} from "react";
import {VdaFilterBar} from "./VdaFilterBar";

const VdaOverviewPage = observer(function VdaOverviewPage() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        pageQueryStore.restore('vda', searchParams, setSearchParams)
    }, [searchParams, setSearchParams])

    return <Page
        breadcrumb={[
            {
                link: '/vda',
                label: `Fahrzeugerfassung`
            }
        ]}
        actions={[
            {
                label: 'Neues Fahrzeug erfassen',
                action: () => navigate('/vda/create'),
                icon: 'add'
            }
        ]}
    >
        <PageContentTitle
            actionItem={<>
                <VdaFilterBar/>
            </>}
        >
            <Searchbar placeholder={"FIN"}/>
        </PageContentTitle>
        <ScrollTable>
            <thead>
            <tr>
                <th>Kunde</th>
                <th>Fahrzeug</th>
                <th>Datum</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody>
            {vdaOverviewStore.items.map((val, index) => {
                const link = `/vda/${val.id}`
                return <tr key={index} onClick={() => {navigate(link)}}>
                    <td><Linq to={`${link}`}>{val.customer}</Linq></td>
                    <td><Linq to={`${link}`}>{val.fin}</Linq></td>
                    <td><Linq to={`${link}`}>{dateFormat(val.date)}</Linq></td>
                    <td><Linq to={`${link}`}>{convertStatus(val.status)}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={vdaOverviewStore.pages} />
    </Page>
})

export {
    VdaOverviewPage
}
